module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDE2IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxLjUiIHJ4PSIwLjc1IiBmaWxsPSIjRTYxQzBBIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/img/minus.svg
// module id = 1728
// module chunks = 1